import { BadgeProps, colors, colorScale } from "@minuthq/meatball-ui-react"

import { TTask } from "./taskManagementTypes"

/**
 * Returns the color of the date badge for a task
 * @param taskTimeWindow
 * @returns "error" if overdue, "neutral" if the start date is in the future, otherwise "info"
 */
export function getTaskDateBadgeColor(task: TTask): BadgeProps["color"] {
  const taskTimeWindow = task.time_window
  const status = task.status
  const defaultColor = "info"

  // If the task is completed, we use default
  if (status === "done") {
    return defaultColor
  }
  const now = new Date()
  const dueDate = new Date(taskTimeWindow.due_date)
  const earliestStartDate = taskTimeWindow.earliest_start_date
    ? new Date(taskTimeWindow.earliest_start_date)
    : undefined

  // Overdue
  if (dueDate < now) {
    return "error"
  }

  // If there is a earliest start date and it's in the future, we set the badge to neutral
  if (earliestStartDate && earliestStartDate > now) {
    return "neutral"
  }

  return defaultColor
}

/**
 * Returns the colors for a task based on its status and due date
 * @param task The task to get colors for
 * @returns Object containing fillColor, color (text color), and borderColor
 */
export function getTaskColors(task: TTask): {
  fillColor: string
  color: string
  borderColor: string
} {
  const status = task.status
  const now = new Date()
  const dueDate = new Date(task.time_window.due_date)

  if (status === "done") {
    return {
      fillColor: colors.systemGoodLight,
      color: colors.systemGoodDark,
      borderColor: colorScale.good[300],
    }
  }

  if (dueDate < now) {
    return {
      fillColor: colors.systemErrorLight,
      color: colors.systemErrorDark,
      borderColor: colorScale.error[300],
    }
  }

  return {
    fillColor: colors.accentPrimaryLight,
    color: colors.systemInfoDark,
    borderColor: colors.accentPrimary,
  }
}
